import { WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledWestRewardsContainer,
    StyledWestRewardsLogo,
    StyledWestRewardsLogoContainer,
    StyledWestRewardsMessage,
    StyledWestRewardsWrapper,
} from './WestRewardsMessageStyled'

export const WestRewardsMessage: React.FC = () => {
    return (
        <StyledWestRewardsWrapper>
            <StyledWestRewardsContainer>
                <StyledWestRewardsMessage>
                    <p>
                        All subscriptions include exclusive subscriber offers,
                        events and giveaways with West Rewards, our subscriber
                        rewards program.
                    </p>
                </StyledWestRewardsMessage>
                <StyledWestRewardsLogoContainer>
                    <WebLink to="https://rewards.thewest.com.au/">
                        <StyledWestRewardsLogo />
                    </WebLink>
                </StyledWestRewardsLogoContainer>
            </StyledWestRewardsContainer>
        </StyledWestRewardsWrapper>
    )
}
